// Assuming the types for login, useNavigate, LoginResponse, and other types are defined in separate files

import React from 'react'
import Layout from '../../components/Layout'
import ForgotForm from '../../components/Form/ForgotForm'
import { Button } from '../../../../components'
import { useNavigate } from 'react-router-dom'
import { PageRoute } from '../../../../routes'
import { useTranslation } from 'react-i18next'

const Forgot: React.FC = () => {
    const { t } = useTranslation()
    const [success, setSuccess] = React.useState(false)
    const navigate = useNavigate()

    return (
        <>
            {!success ? (
                <Layout
                    pageTitle={t('auth.forgot.title')}
                    pageDescription={t('auth.forgot.description')}
                >
                    <ForgotForm onSuccess={setSuccess} />
                </Layout>
            ) : (
                <Layout
                    pageTitle={t('auth.forgot.title')}
                    pageDescription={t('auth.forgot.suceessDescription')}
                    pageBody={<></>}
                >
                    <Button
                        onClick={() => {
                            navigate(PageRoute.Login)
                        }}
                        variant="outline-success-round"
                    >
                        {t('button.backToLogin')}
                    </Button>
                </Layout>
            )}
        </>
    )
}

export default Forgot
